<template>
  <div id="feature">
    <v-container>
      <v-row justify="center" class="mt-5">
        <v-col md="12">
          <h1 class="tw-text-2xl tw-font-bold tw-mb-5">ฟีเจอร์</h1>

          <div class="wrapper">

            <div class="box-wrapper">
              <div class="box">
                <img src="/images/icons/feature-1.svg" alt="feature">
                <h2>เชื่อมต่อกับโปรแกรมบัญชีชั้นนำอัตโนมัติ</h2>
                <p></p>
              </div>
            </div>

            <div class="box-wrapper">
              <div class="box">
                <img src="/images/icons/feature-2.svg" alt="feature">
                <h2>ส่ง e-Tax invoice อัตโนมัติให้ลูกค้าทาง Email</h2>
                <p></p>
              </div>
            </div>

            <div class="box-wrapper">
              <div class="box">
                <img src="/images/icons/feature-3.svg" alt="feature">
                <h2>เตรียมไฟล์ e-Tax invoice พร้อมส่งให้กรมสรรพากรเพียงแค่ปลายนิ้ว</h2>
                <p>ไฟล์ XML/Zip ตามรูปแบบที่สรรพากรต้องการ</p>
              </div>
            </div>

            <div class="box-wrapper">
              <div class="box">
                <img src="/images/icons/feature-4.svg" alt="feature">
                <h2>แจ้งสรุปยอดขายรายวันได้ง่ายๆ ผ่าน Line Application</h2>
                <p></p>
              </div>
            </div>

            <div class="box-wrapper">
              <div class="box">
                <img src="/images/icons/feature-5.svg" alt="feature">
                <h2>หน้ารายงานสรุปผล ใช้เปรียบเทียบ
                  ยอดขายรายวัน รายสัปดาห์ รายปี
                  ผ่าน Email</h2>
                <p></p>
              </div>
            </div>

          </div>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Feature',
}
</script>

<style lang="scss">
#feature {
  text-align: center;
  width: 100%;
  background-color: #f2f2f2;

  .wrapper {
    text-align: left;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    display: flex;
    align-items: stretch;

    .box-wrapper {
      width: 32%;
      margin: 8px 0.5%;
      //margin: 0 auto 20px;
      //margin-bottom: 20px;
      display: flex;
      align-items: stretch;

      .box {
        text-align: left;
        padding: 20px 20px 10px;
        width: 100%;
        border-radius: 20px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;

        h2 {
          font-size: 20px;
          position: relative;
          margin-bottom: 10px;
          min-height: 60px;
          text-align: center;

          &:before {
            content: '';
            width: 4px;
            height: 60px;
            background: #c9242b;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            position: absolute;
            left: -20px;
          }
        }

        img {
          display: block;
          margin: 0 auto 20px;
          max-width: 165px;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .box-wrapper {
      width: 49% !important;
    }
  }
  @media only screen and (max-width: 425px) {
    .box-wrapper {
      width: 100% !important;
    }
  }
}
</style>
